import { TICKET_GET, TICKET_LIST, FEEDBACK_ENGINEERS_ADMIN, ENGINEER_ADMIN_TICKETS, TICKET_COUNTS_ENG, COMPANY_LIST, TICKET_BY_COMPANY, EXISTING_TICKET, SUPERVISOR_TICKET_LIST, REQUESTER_TICKET_LIST, ENGINEER_TICKET_LIST, ADD_TICKET, ENGINEERS_LIST, PRIORITY_LIST, TYPE_LIST, STATUS_LIST, GROUPS_LIST, SUB_CAT_LIST, TICKET_COUNTS, FEEDBACK_LIST, TICKET_DISCUSSION_LIST_BY_TICKET, FILTERED_TICKETS, TICKET_REPORT, TIMER_STATUS, TICKET_UPDATE_BY_ENG, TICKET_UPDATE_BY_SUP, REQUESTER_LIST, PAGINATED_TICKETS_LIST, TICKET_SEARCH, SET_FEEDBACK_MESSAGE, FETCH_TICKET_COUNT, UPDATE_DASHBOARD_COUNTS, FILTER_TICKETS_BY_STATUS, CLEAR_SEARCH_RESULTS, DASHBOARD_DETAILS } from '../actions/types';
const initialState: any = {
    ticketList: [],
    ticket: {},
    existing_ticket: "",
    assigneeTicketList: [],
    requesterTicketList: [],
    supervisorTicketList: [],
    priority: [],
    ticketByComp: [],
    status: [],
    supervisorStatus: [],
    engineerStatus: [],
    pausedStatus: [],
    resumeStatus: [],
    groups: [],
    requester: [],
    types: [],
    companies: [],
    feedbacks: [],
    ticketCounts: {},
    dashboardDetails: null,
    ticket_count_eng: {},
    feedbacks_eng: [],
    subCategory: [],
    engineers: [],
    tickets_eng: [],
    isInserted: "",
    message: "",
    ticket_discussion_list: [],
    filteredOrders: [],
    emptyFilterOrder: false,
    ticketsReceived: 0,
    ticketsAssigned: 0,
    ticketsResolved: 0,
    ticketsPaused: 0,
    ticketsClosed: 0,
    ticketsTotal: 0,
    timerStatus: true,
    // paginated tickets list
    ticketsList: [],
    pageCount: 0,
    currentPage: 0,
    loading: false,
    searchResults: [],
    searchLoading: false,
    failureResults: '',
    ticketCount: 0,
};
const TicketReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case TICKET_LIST:
            return {
                ...state,
                ticketList: action.payload,
                ticketsReceived: action.ticketsReceived,
                ticketsAssigned: action.ticketsAssigned,
                ticketsResolved: action.ticketsResolved,
                ticketsPaused: action.ticketsPaused,
                ticketsClosed: action.ticketsClosed
            };
        // Paginated Coupons Reducers Cases
        case PAGINATED_TICKETS_LIST + '_REQUEST': // Set loading to true when making a request
            return {
                ...state,
                loading: true,
            };
        case PAGINATED_TICKETS_LIST + '_SUCCESS': // Set loading to false when data is successfully fetched
            let page = action.payload.currentPage;
            let pageSize = 20;
            return {
                ...state,
                ticketsList: action.payload.ticketsData,
                pageCount: Math.ceil(action.payload.totalTickets / pageSize),
                currentPage: page,
                loading: false,
            };
        //   Search Coupons Reducer
        case TICKET_SEARCH + '_REQUEST': // Set loading to true when making a request
            return {
                ...state,
                searchLoading: true,
            };
        case TICKET_SEARCH + '_SUCCESS': // Set loading to false when data is successfully fetched
            let ticketData = action.payload;
            return {
                ...state,
                searchResults: ticketData,
                searchLoading: false,
            };
        case TICKET_SEARCH + '_FAILURE':
            return {
                ...state,
                failureResults: [{ message: action.message }],
                searchLoading: false,
            };
        case FETCH_TICKET_COUNT:
            return {
                ...state,
                ticketCount: action.payload,
            };

        case UPDATE_DASHBOARD_COUNTS:
            return {
                ...state,
                ticketsReceived: action.payload.ticketsReceived,
                ticketsAssigned: action.payload.ticketsAssigned,
                ticketsResolved: action.payload.ticketsResolved,
                ticketsPaused: action.payload.ticketsPaused,
                ticketsClosed: action.payload.ticketsClosed,
                ticketsTotal: action.payload.ticketsTotal
            };
        case DASHBOARD_DETAILS:
            return {
                ...state,
                dashboardDetails: action.payload,
                ticketsReceived: action.payload?.ticketsReceived ?? 0,
                ticketsAssigned: action.payload?.ticketsAssigned ?? 0,
                ticketsResolved: action.payload?.ticketsResolved ?? 0,
                ticketsPaused: action.payload?.ticketsPaused ?? 0,
                ticketsClosed: action.payload?.ticketsClosed ?? 0,
                ticketsTotal: action.payload?.ticketsTotal ?? 0
            };
        case FILTER_TICKETS_BY_STATUS:
            return {
                ...state,
                ticketsList: action.payload,
                pageCount: action.pageCount,
                currentPage: action.currentPage,
                loading: false,
            };
        case ENGINEER_TICKET_LIST:
            return {
                ...state,
                assigneeTicketList: action.payload
            }
        case FEEDBACK_ENGINEERS_ADMIN:
            return {
                ...state,
                feedbacks_eng: action.payload
            }
        case ENGINEER_ADMIN_TICKETS:
            return {
                ...state,
                tickets_eng: action.payload
            }
        case SUPERVISOR_TICKET_LIST:
            return {
                ...state,
                supervisorTicketList: action.payload
            }
        case TICKET_BY_COMPANY:
            return {
                ...state,
                ticketByComp: action.payload
            }
        case COMPANY_LIST:
            return {
                ...state,
                companies: action.payload
            }
        case FEEDBACK_LIST:
            return {
                ...state,
                feedbacks: action.payload
            }
        case REQUESTER_TICKET_LIST:
            return {
                ...state,
                requesterTicketList: action.payload
            }

        case ADD_TICKET: return {
            ...state,
            isLoad: action.isLoad,
            isInserted: action.isInserted,
            message: action.payload
        }
        case PRIORITY_LIST: return {
            ...state,
            priority: action.payload
        };
        case GROUPS_LIST: return {
            ...state,
            groups: action.payload
        };
        case REQUESTER_LIST: return {
            ...state,
            requester: action.payload
        };
        case TICKET_COUNTS: return {
            ...state,
            ticketCounts: action.payload
        };
        case TICKET_COUNTS_ENG: return {
            ...state,
            ticket_count_eng: action.payload
        };
        case STATUS_LIST: return {
            ...state,
            status: action.payload,
            supervisorStatus: action.supervisorStatus,
            engineerStatus: action.engineerStatus,
            pausedStatus: action.pausedStatus,
            resumeStatus: action.resumeStatus
        };
        case TICKET_UPDATE_BY_ENG: return {
            ...state,
            isLoad: action.isLoad,
            ticket: action.payload || state.ticket
        }
        case TICKET_UPDATE_BY_SUP: return {
            ...state,
            isLoad: action.isLoad,
            ticket: action.payload || state.ticket
        }
        case TYPE_LIST: return {
            ...state,
            types: action.payload
        };
        case SUB_CAT_LIST: return {
            ...state,
            subCategory: action.payload
        };
        case ENGINEERS_LIST: return {
            ...state,
            engineers: action.payload
        };
        case EXISTING_TICKET: return {
            ...state,
            existing_ticket: action.payload,
            message: action.payload
        };
        case SET_FEEDBACK_MESSAGE: return {
            ...state,
            message: action.payload,
            isFeedbackSubmitted: true // Add this flag
        };
        case TICKET_GET: return {
            ...state,
            ticket: action.payload
        };
        case TICKET_DISCUSSION_LIST_BY_TICKET: return {
            ...state,
            ticket_discussion_list: action.payload
        };
        case FILTERED_TICKETS: return {
            ...state,
            filteredOrders: action.payload,
            emptyFilterOrder: action.emptyFilterOrder
        }
        case TIMER_STATUS: return {
            ...state,
            timerStatus: action.payload == false ? false : true
        }
        case CLEAR_SEARCH_RESULTS:
            return {
                ...state,
                searchResults: [],
                searchLoading: false
            };
        default:
            return state;
    }
};
export default TicketReducer;